/**
 * Opt-outs for a container whose labels or links name the owner's own picks (Stats > Website's filters: hosts, pages,
 * sources, links, affiliates, campaigns, countries). Google Analytics' click listener skips every click inside
 * `[data-analytics-redact]` (`googleAnalytics.ts`), and the Pulsar beacon skips `[data-track-ignore]`. Spread both on
 * the container's root element, so neither tracker records a click in it: `<List {...TRACKING_OPT_OUT}>`.
 */
export const TRACKING_OPT_OUT = { 'data-analytics-redact': '', 'data-track-ignore': '' } as const;

/** The containers Google Analytics' click listener skips. */
export const ANALYTICS_REDACT_SELECTOR = '[data-analytics-redact]';
